// import { UserItem } from '@context/AuthContext';
import { Button, Grid, Typography } from '@material-ui/core';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import { Box } from '@material-ui/system';
import { Formik } from 'formik';
import moment from 'moment';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import PlainLayout from '../layouts/PlainLayout';
import Controls from '../components/controls/Controls';
import { firebaseStore } from '../storage/base';
import { sendEmail } from '../utils/communication/sendEmail';

const RemoveData = () => {
  const navigate = useNavigate();
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const [errors, setErrors] = useState('');
  const [success, setSuccess] = useState('');
  const [showClose, setShowClose] = useState(false);

  const handleFormSubmit = async (values) => {
    console.log('values at submit', values);
    // console.log('values at localStorage.getItem ', loggedUid)
    // sendEmails(values)

    // let existUser: UserItem[] = [];
    await firebaseStore
      .database()
      .ref()
      .child('Users')
      .orderByChild('email')
      .equalTo(values.email)
      .limitToLast(1)
      .once('value', (snapshot) => {
        console.log('exist suer222', snapshot.val());
        if (!snapshot.val()) {
          setShowClose(true);
          notifyPopup(
            `The Provided email does not exist in our database.  We are unable to process the request..!`,
            'error'
          );
          setErrors(
            'The Provided email does not exist in our database.  We are unable to process the request..'
          );
        } else {
          handleSave(values);
        }
      });
  };

  const handleSave = async (values) => {
    // @ts-ignore: Object is possibly 'null'.
    let cancelNo = 1;
    await firebaseStore
      .database()
      .ref('Cancellations')
      .orderByChild('cancelId')
      .limitToLast(1)
      .once('value')
      .then((snapshot) => {
        snapshot.forEach((childSnapshot) => {
          cancelNo = childSnapshot.val().id + 1;
          console.log('cancelId No in if main', cancelNo);
        });
      });
    const requestDate = new Date();
    await firebaseStore.database().ref('Cancellations').child(cancelNo.toString()).set({
      // @ts-ignore: Object is possibly 'null'.
      id: cancelNo,
      emailAddress: values.email,
      dateRequested: requestDate.toString(),
      dataToDelete: values.dataToDelete
    });

    sendEmails(values);

    notifyPopup(
      `Data deletion request has been sent successfully and will be actioned within next 2 days..!`,
      'success'
    );
    setSuccess(
      'Data deletion request has been sent successfully and will be actioned within next 2 days..'
    );
    setShowClose(true);
  };

  const paymentHtml = `<table border="0" style="width: 67.3012%; border-collapse: collapse;">
    <tbody>
    <tr bgcolor="#ededed">
    <td style="width: 33.8746%;">
    <h2 style="color: #e400ff"><strong>ZIMTA</strong></h2>
    </td>
    <td style="width: 33.5371%;"><strong>Data Delete Request to ZIMTA</strong></td>
    </tr>
    <tr bgcolor="#f8f8f8">
    <td style="width: 33.8746%;"><span><strong>Date:</strong>&nbsp;<a>~sendDate~</a></span></td>
    <td style="width: 33.5371%; text-align: right;"><span><strong>Account Email:</strong>&nbsp;~email~</span></td>
    </tr>
    </tbody>
    </table>
    <table border="0" width="600" cellpadding="0" cellspacing="0" bgcolor="#ffffff">
    <tbody>
    <tr>
    <td bgcolor="#ffffff" align="left"><span>Request to Delete Kept Data: ,<br /><br />~dataToDelete~.<br /><br /><br /><br />From Web - Data Deletion Request,<br />directCred</span></td>
    </tr>
    </tbody>
    </table>`;

  const sendEmails = async (data) => {
    const paymentHtml0 = paymentHtml.trim().replace('~firstName~', 'data.firstName');
    const paymentHtml2 = paymentHtml0.trim().replace('~lastName~', 'data.lastName');
    const paymentHtml3 = paymentHtml2.trim().replace('~email~', data.email);
    const paymentHtml4 = paymentHtml3.trim().replace('~sendDate~', moment().format('DD-MMM-YYYY'));
    const paymentHtml5 = paymentHtml4.trim().replace('~dataToDelete~', data.dataToDelete);

    const msg = await sendEmail.createEmail(
      'Contact Us',
      'From ZIMTA web',
      data.email,
      paymentHtml5
    );
    const result = await msg;
    // .then(
    //     (res) => {
    //         console.log('ayep yep from save contact us', res)
    //     },
    //     (error) => {
    //         alert(`failed here ayep ${{ error }}`);
    //     })
    // const response = await send.json();

    console.log('send response', result);
  };

  const handleClose = () => {
    navigate(`/`);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <>
      {/* <Card1> */}
      <Formik
        initialValues={initialValues}
        validationSchema={checkoutSchema}
        onSubmit={handleFormSubmit}
      >
        {({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box mb={4}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                  <Controls.Input name="email" label="Email" />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <Controls.Input name="dataToDelete" label="Specify Data to Delete...e.g. All" />
                </Grid>
              </Grid>
              <Grid
                container
                margin={2}
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Grid item xs={12} sm={3}>
                  {!showClose && (
                    <Button
                      type="submit"
                      variant="outlined"
                      startIcon={<MailOutlineIcon />}
                      // onClick={() => sendEmails()}
                    >
                      Send Request
                    </Button>
                  )}
                  {showClose && (
                    <Button
                      type="button"
                      variant="outlined"
                      startIcon={<MailOutlineIcon />}
                      onClick={() => handleClose()}
                    >
                      Close
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Box>
          </form>
        )}
      </Formik>
      <Box>
        <Typography color="error" variant="h6">
          {errors && <div>{errors}</div>}
        </Typography>
        <Typography color="primary" variant="h6">
          {success && <div>{success}</div>}
        </Typography>
      </Box>
      <Controls.Notification notify={notify} setNotify={setNotify} />
      {/* </Card1> */}
    </>
  );
};

const initialValues = {
  firstName: '',
  lastName: '',
  message: '',
  email: '',
  cellNumber: '',
  subject: '',
  sent: false
};

const checkoutSchema = yup.object().shape({
  // firstName: yup.string().required('required'),
  dataToDelete: yup.string().required('Type of removal is required'),
  email: yup.string().required('The email field is required')
});

RemoveData.layout = PlainLayout;

export default RemoveData;
